import {
  MIGRATE_PROJECT_ACTION,
  ROLES_ACTION,
  STATUS,
  USER_MANAGEMENT_ACTION
} from "../constant";

const initState = {
  groupsList: [],
  groups: [],
  rolesList: [], // for create group
  permissionListing: [], // for permission listing page
  usersListing: [], // for permission listing page
  bestPracticesList: [],
  categoryList: [],
  isApiLoading: null,
  isProjectListLoading: false,
  isProjectMigrating: false,
  projectMigratingData: {},
  otpResponse: {},
  projectList: {},
  migrateFormData: {},
  usersListDownload: {
    show: true,
    title: "Users List",
    isLoading: false,
    downloadingSrc: ""
  },
  groupsListDownload: {
    show: true,
    title: "Groups List",
    isLoading: false,
    downloadingSrc: ""
  }
};

export default (state = initState, action) => {
  switch (action.type) {
    case USER_MANAGEMENT_ACTION.GET_ROLES_LIST_START:
    case USER_MANAGEMENT_ACTION.DELETE_GROUP_START:
    case USER_MANAGEMENT_ACTION.CREATE_USER_START:
    case USER_MANAGEMENT_ACTION.GET_GROUP_LIST_FILTER_START:
    case ROLES_ACTION.GET_PERMISSIONS_LIST_START:
    case ROLES_ACTION.CREATE_ROLES_START:
      return { ...state, isApiLoading: STATUS.LOADING };

    case USER_MANAGEMENT_ACTION.CREATE_GROUP_START:
      return { ...state, isApiLoading: STATUS.LOADING, groupsList: [] };

    case USER_MANAGEMENT_ACTION.GET_GROUP_LIST_START:
    case USER_MANAGEMENT_ACTION.GET_GROUPS_START:
    case USER_MANAGEMENT_ACTION.GET_GROUPS_FOR_USER_START:
      return { ...state, isGroupListLoading: STATUS.LOADING };

    case USER_MANAGEMENT_ACTION.GET_USERS_LIST_START:
      return { ...state, isUserListLoading: STATUS.LOADING };

    case ROLES_ACTION.CREATE_ROLES_SUCCESS:
      return { ...state, isApiLoading: STATUS.SUCCESS };

    case USER_MANAGEMENT_ACTION.GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        usersListing: action.payload,
        isUserListLoading: STATUS.SUCCESS
      };

    case USER_MANAGEMENT_ACTION.GET_USERS_LIST_FAILURE:
      return { ...state, isUserListLoading: STATUS.ERROR };

    case USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_START:
      return { ...state, isBestPracticesLoading: STATUS.LOADING };

    case USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_SUCCESS:
      return {
        ...state,
        bestPracticesList: action.payload,
        isBestPracticesLoading: STATUS.SUCCESS
      };

    case USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_FAILURE:
      return { ...state, isBestPracticesLoading: STATUS.ERROR };

    case USER_MANAGEMENT_ACTION.CREATE_GROUP_FAILURE:
    case USER_MANAGEMENT_ACTION.GET_ROLES_LIST_FAILURE:
    case USER_MANAGEMENT_ACTION.DELETE_GROUP_FAILURE:
    case USER_MANAGEMENT_ACTION.CREATE_USER_FAILURE:
    case ROLES_ACTION.GET_PERMISSIONS_LIST_FAILURE:
      return { ...state, isApiLoading: STATUS.ERROR };

    case USER_MANAGEMENT_ACTION.GET_GROUPS_FAILURE:
    case USER_MANAGEMENT_ACTION.GET_GROUP_LIST_FAILURE:
    case USER_MANAGEMENT_ACTION.GET_GROUPS_FOR_USER_FAILURE:
    case USER_MANAGEMENT_ACTION.GET_GROUP_LIST_FILTER_FAILURE:
      return { ...state, isGroupListLoading: STATUS.ERROR };

    case USER_MANAGEMENT_ACTION.GET_GROUP_LIST_SUCCESS:
      return {
        ...state,
        groupsList: action.payload,
        isGroupListLoading: STATUS.SUCCESS
      };

    case USER_MANAGEMENT_ACTION.GET_ROLES_LIST_SUCCESS:
      return {
        ...state,
        rolesList: action.payload,
        isApiLoading: STATUS.SUCCESS
      };

    case USER_MANAGEMENT_ACTION.GET_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        categoryList: action.payload,
        isApiLoading: STATUS.SUCCESS
      };

    case USER_MANAGEMENT_ACTION.GET_GROUP_LIST_FILTER_SUCCESS:
      return {
        ...state,
        groupListFilter: action.payload,
        isApiLoading: STATUS.SUCCESS
      };

    case USER_MANAGEMENT_ACTION.GET_CATEGORY_LIST_FOR_ROLE_SUCCESS:
      return {
        ...state,
        categoryForRoleList: action.payload,
        isApiLoading: STATUS.SUCCESS
      };

    case USER_MANAGEMENT_ACTION.GET_GROUPS_SUCCESS:
    case USER_MANAGEMENT_ACTION.GET_GROUPS_FOR_USER_SUCCESS:
      return {
        ...state,
        groups: action.payload,
        isGroupListLoading: STATUS.SUCCESS
      };

    case ROLES_ACTION.GET_PERMISSIONS_LIST_SUCCESS:
      return {
        ...state,
        permissionListing: action.payload,
        isApiLoading: STATUS.SUCCESS
      };

    case USER_MANAGEMENT_ACTION.CREATE_GROUP_SUCCESS:
    case USER_MANAGEMENT_ACTION.DELETE_GROUP_SUCCESS:
    case USER_MANAGEMENT_ACTION.CREATE_USER_SUCCESS:
    case ROLES_ACTION.CREATE_ROLES_FAILURE:
      return {
        ...state,
        isApiLoading: STATUS.SUCCESS
      };

    case MIGRATE_PROJECT_ACTION.MIGRATE._START:
      return {
        ...state,
        isProjectMigrating: true
      };

    case MIGRATE_PROJECT_ACTION.MIGRATE._SUCCESS:
      return {
        ...state,
        isProjectMigrating: false,
        projectMigratingData: action.payload
      };

    case MIGRATE_PROJECT_ACTION.MIGRATE._FAILURE:
      return {
        ...state,
        isProjectMigrating: false
      };

    case MIGRATE_PROJECT_ACTION.PROJECT_LIST._START:
      return {
        ...state,
        isProjectListLoading: true,
        projectList: {}
      };

    case MIGRATE_PROJECT_ACTION.PROJECT_LIST._SUCCESS:
      return {
        ...state,
        isProjectListLoading: false,
        projectList: action.payload
      };

    case MIGRATE_PROJECT_ACTION.PROJECT_LIST._FAILURE:
      return {
        ...state,
        isProjectListLoading: false,
        projectList: {}
      };

    case MIGRATE_PROJECT_ACTION.MIGRATE._CLEAR:
      return {
        ...state,
        isProjectListLoading: false,
        projectList: {},
        migrateFormData: {}
      };

    case MIGRATE_PROJECT_ACTION.MIGRATE._UPDATE:
      return {
        ...state,
        isProjectListLoading: false,
        migrateFormData: action.payload
      };

    case USER_MANAGEMENT_ACTION.USERS_LIST._START:
      return {
        ...state,
        usersListDownload: {
          ...state.usersListDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case USER_MANAGEMENT_ACTION.USERS_LIST._SUCCESS:
      return {
        ...state,
        usersListDownload: {
          ...state.usersListDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case USER_MANAGEMENT_ACTION.USERS_LIST._FAILURE:
      return {
        ...state,
        usersListDownload: {
          ...state.usersListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case USER_MANAGEMENT_ACTION.USERS_LIST._CLEAR:
      return {
        ...state,
        usersListDownload: {
          ...state.usersListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case USER_MANAGEMENT_ACTION.GROUPS_LIST._START:
      return {
        ...state,
        groupsListDownload: {
          ...state.groupsListDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case USER_MANAGEMENT_ACTION.GROUPS_LIST._SUCCESS:
      return {
        ...state,
        groupsListDownload: {
          ...state.groupsListDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case USER_MANAGEMENT_ACTION.GROUPS_LIST._FAILURE:
      return {
        ...state,
        groupsListDownload: {
          ...state.groupsListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case USER_MANAGEMENT_ACTION.GROUPS_LIST._CLEAR:
      return {
        ...state,
        groupsListDownload: {
          ...state.groupsListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case USER_MANAGEMENT_ACTION.GET_USER_OTP_START:
      return { ...state, otpStatus: STATUS.LOADING };
    case USER_MANAGEMENT_ACTION.GET_USER_OTP_SUCCESS: {
      return {
        ...state,
        otpResponse: action.payload,
        otpStatus: STATUS.SUCCESS
      };
    }
    case USER_MANAGEMENT_ACTION.GET_USER_OTP_FAILURE:
      return { ...state, otpStatus: STATUS.ERROR };

    default:
      return state;
  }
};
